document.addEventListener('DOMContentLoaded', () => {
  const landingSwiper = new Swiper('.js-landing-slide', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 50,

    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
});
